export const SET_SELECTED_AFFILIATE = 'affiliates/SET_SELECTED_AFFILIATE';
export const SET_SELECTED_CAMPAIGN = 'affiliates/SET_SELECTED_CAMPAIGN';
